"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOptions = exports.tooltipOptions = void 0;
var design_system_colors_1 = require("../../../style/theme/design-system-colors");
var constants_1 = require("./constants");
exports.tooltipOptions = {
    backgroundColor: design_system_colors_1.DesignSystemColor.Gray.DARK_4,
    borderWidth: 0,
    borderRadius: 2,
    shadow: false,
    style: {
        color: 'white',
    },
};
var buildOptions = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, width = _a.width, height = _a.height, margin = _a.margin, marginTop = _a.marginTop, marginRight = _a.marginRight, marginBottom = _a.marginBottom, marginLeft = _a.marginLeft;
    return ({
        chart: {
            width: width,
            height: height,
            margin: margin,
            marginTop: marginTop,
            marginRight: marginRight,
            marginBottom: marginBottom,
            marginLeft: marginLeft,
        },
        colors: constants_1.CHART_COLORS,
        title: title ? { text: title, useHTML: true } : undefined,
        subtitle: subtitle ? { text: subtitle, useHTML: true } : undefined,
        credits: {
            enabled: false,
        },
        tooltip: exports.tooltipOptions,
    });
};
exports.buildOptions = buildOptions;
